<p-dropdown [panelStyleClass]="classStyle"  [options]="options" optionLabel="name" [(ngModel)]="selectedOption" appendTo="body"
(onChange)="onPeriodChanged()" [placeholder]="translate('SELECT_TIME_PERIOD')">
  <ng-template pTemplate="selectedItem">
      <div *ngIf="selectedOption">{{selectedOption.name}}{{formattedTimePeriods}}</div>
  </ng-template>
  <ng-template let-period pTemplate="item">
      <div>{{period.name}}</div>
  </ng-template>
</p-dropdown>
